var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-progress-line"},_vm._l((_vm.getList),function(item,index){return _c('div',{key:index,staticClass:"line",class:item.class})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }